import { Mail, MessageCircle, Smartphone } from "lucide-react";

const MODES = [
  { id: "phone", label: "WhatsApp", icon: MessageCircle, testId: "mode-phone-btn" },
  { id: "sms", label: "SMS", icon: Smartphone, testId: "mode-sms-btn" },
  { id: "email", label: "Email", icon: Mail, testId: "mode-email-btn" },
];

export const AuthModeTabs = ({ mode, onChange }) => (
  <div className="mt-7 flex border border-slate-300">
    {MODES.map(({ id, label, icon: Icon, testId }) => (
      <button
        key={id}
        data-testid={testId}
        onClick={() => onChange(id)}
        className={`flex h-10 flex-1 items-center justify-center gap-1.5 text-xs font-semibold uppercase tracking-wide transition-colors ${
          mode === id
            ? "bg-[#1A365D] text-white"
            : "bg-white text-slate-600 hover:text-[#1A365D]"
        }`}
      >
        <Icon className="h-3.5 w-3.5" /> {label}
      </button>
    ))}
  </div>
);